<form>
  <div class="row" *ngIf="!isLoading">
    <div class="col-md-12 col-xl-12">
      <div class="table-responsive our-table">
        <table class="table table-striped text-nowrap mb-0">
          <thead class="border-top">
            <tr>
              <th scope="col" class="text-capitalize">
                {{ "common.date" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.transactionId" | translate }}
              </th>
              <th scope="col" class="text-capitalize"></th>
              <th scope="col" class="text-capitalize">
                {{ "common.type" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.status" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.requestedValue" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.fees" | translate }}
              </th>
              <th scope="col" class="text-capitalize">{{ nameColumn }}</th>
              <th scope="col" class="text-capitalize">
                {{ "common.amountMoved" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.origin" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.description" | translate }}
              </th>
              <th scope="col" class="text-capitalize">
                {{ "common.externalId" | translate }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr class="border-bottom" *ngFor="let transaction of transactions">
              <td>
                <span>{{
                  transaction.data | date : "dd/MM/yyyy HH:mm:ss" : "GMT"
                }}</span>
              </td>
              <td>
                <span>{{ transaction.codigo }}</span>
              </td>
              <td>
                <span>
                  <i
                    class="btn btn-sm fe fe-search"
                    (click)="openDetails(transaction)"
                  ></i>
                </span>
              </td>
              <td>
                <span class="text-{{ transaction.textColor }}">{{
                  transaction.tipo | label : "type"
                }}</span>
              </td>
              <td>
                <span>{{ transaction.status }}</span>
              </td>
              <td>
                <span>{{ transaction.valorSolicitado | formatCurrency }}</span>
              </td>
              <td>
                <span>{{
                  (!transaction.splitTaxa && !transaction.splitTaxaAdm
                    ? transaction.taxaAdministrativa
                    : transaction.splitTaxaAdm
                  ) | formatCurrency
                }}</span>
              </td>
              <td>
                <span>{{ transaction.splitTaxa | formatCurrency }}</span>
              </td>
              <td>
                <span>{{ transaction.valorMovimentado | formatCurrency }}</span>
              </td>
              <td>
                <span>{{
                  mapOrigin(transaction.origem || transaction.origin)
                }}</span>
              </td>
              <td>
                <span>{{ transaction.responsavel }}</span>
              </td>
              <td>
                <span>{{ transaction.idempotencyKey }}</span>
              </td>
            </tr>
            <tr *ngIf="transactions.length == 0">
              <td colspan="12">{{ "common.noData" | translate }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between p-2">
        <ngb-pagination
          [collectionSize]="total"
          [maxSize]="5"
          [rotate]="true"
          [(page)]="page"
          [pageSize]="pageSize"
          (pageChange)="pageChange()"
        >
        </ngb-pagination>
      </div>
    </div>
  </div>
</form>

<ng-template #transactionDetailsModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      {{ "common.transactionDetails" | translate }} – #{{
        selectedTransaction?.id ||
          selectedTransaction?.identifier ||
          selectedTransaction?.codigo
      }}
    </h5>
    <button class="btn-close" (click)="modal.close()"></button>
  </div>

  <ng-container *ngIf="selectedTransaction; else loading">
    <div class="modal-body p-0">
      <div class="table-responsive">
        <table class="table table-sm mb-0">
          <tbody>
            <!-- ====================== BÁSICO ====================== -->
            <tr>
              <th>{{ "common.identifier" | translate }}</th>
              <td>
                {{
                  selectedTransaction.identifier ||
                    selectedTransaction.codigo ||
                    "-"
                }}
              </td>
            </tr>
            <tr>
              <th>{{ "common.bankId" | translate }}</th>
              <td>{{ selectedTransaction.endToEndId || "-" }}</td>
            </tr>
            <tr>
              <td colspan="2" class="p-4"></td>
            </tr>
            <tr>
              <th>{{ "common.dateIssue" | translate }}</th>
              <td>
                {{
                  fmtDate(
                    selectedTransaction.dateIssue || selectedTransaction.data
                  )
                }}
              </td>
            </tr>
            <tr>
              <th>{{ "common.confirmationDate" | translate }}</th>
              <td>{{ fmtDate(selectedTransaction.confirmationDate) }}</td>
            </tr>
            <tr>
              <td colspan="2" class="p-4"></td>
            </tr>
            <tr>
              <th>{{ "common.type" | translate }}</th>
              <td>
                {{ selectedTransaction.type || selectedTransaction.tipo }}
              </td>
            </tr>
            <tr>
              <th>{{ "common.status" | translate }}</th>
              <td>
                <span
                  *ngIf="selectedTransaction.status"
                  class="status-badge"
                  [ngClass]="formatStatusClass(selectedTransaction.status)"
                >
                  {{ selectedTransaction.status | label : "status" }}
                </span>
                <span *ngIf="!selectedTransaction.status">-</span>
              </td>
            </tr>
            <tr>
              <th>{{ "common.origin" | translate }}</th>
              <td>
                {{ selectedTransaction.origin || selectedTransaction.origem }}
              </td>
            </tr>
            <tr>
              <th>{{ "common.application" | translate }}</th>
              <td>
                {{
                  selectedTransaction.application ||
                    selectedTransaction.aplicacao
                }}
              </td>
            </tr>
            <tr>
              <td colspan="2" class="p-4"></td>
            </tr>

            <!-- ====================== PERSON ====================== -->
            <ng-container *ngIf="selectedTransaction.person as p">
              <tr>
                <th>{{ "common.document" | translate }}</th>
                <td>{{ p.cpf || "-" }}</td>
              </tr>
              <tr>
                <th>{{ "common.name" | translate }}</th>
                <td>{{ p.name }}</td>
              </tr>
              <tr
                *ngIf="
                  (selectedTransaction.type || selectedTransaction.tipo) ===
                  'SAQUE'
                "
              >
                <th>{{ "common.keyType" | translate }}</th>
                <td>{{ p.pixKeyTypes }}</td>
              </tr>
              <tr
                *ngIf="
                  (selectedTransaction.type || selectedTransaction.tipo) ===
                  'SAQUE'
                "
              >
                <th>{{ "common.pixKey" | translate }}</th>
                <td>{{ p.pixKey }}</td>
              </tr>
              <tr>
                <th>{{ "common.bankName" | translate }}</th>
                <td>{{ p.bankName || "-" }}</td>
              </tr>
              <tr
                *ngIf="
                  (selectedTransaction.type || selectedTransaction.tipo) ===
                  'DEPOSITO'
                "
              >
                <th>{{ "common.payerDocument" | translate }}</th>
                <td>{{ p.cpfMask || "-" }}</td>
              </tr>
              <tr>
                <td colspan="2" class="p-4"></td>
              </tr>
            </ng-container>

            <!-- ====================== METADADOS ====================== -->
            <tr>
              <th>{{ "common.callbackUrl" | translate }}</th>
              <td>{{ selectedTransaction.callbackUrl || "-" }}</td>
            </tr>
            <tr>
              <th>{{ "common.externalId" | translate }}</th>
              <td>{{ selectedTransaction.idempotencyKey || "-" }}</td>
            </tr>
            <tr>
              <th>{{ "common.ip" | translate }}</th>
              <td>{{ selectedTransaction.ip || "-" }}</td>
            </tr>
            <tr>
              <th>{{ "common.accountUser" | translate }}</th>
              <td>{{ selectedTransaction.userApprove || "-" }}</td>
            </tr>
            <tr>
              <th>{{ "common.cancelReason" | translate }}</th>
              <td>{{ selectedTransaction.mensageCancel || "-" }}</td>
            </tr>
            <tr>
              <td colspan="2" class="p-4"></td>
            </tr>

            <!-- ====================== VALORES ====================== -->
            <tr>
              <th>{{ "common.requestedValue" | translate }}</th>
              <td>
                {{
                  selectedTransaction.requestedValue ??
                    selectedTransaction.valorSolicitado | formatCurrency
                }}
              </td>
            </tr>
            <tr>
              <th>{{ "common.fee" | translate }}</th>
              <td>
                {{
                  selectedTransaction.splitTaxaAdm ??
                    selectedTransaction.taxaAdministrativa | formatCurrency
                }}
              </td>
            </tr>
            <tr>
              <th>{{ "common.split" | translate }}</th>
              <td>{{ selectedTransaction.splitTaxa | formatCurrency }}</td>
            </tr>
            <tr>
              <th>{{ "common.amountMoved" | translate }}</th>
              <td>
                {{
                  selectedTransaction.movedValue ??
                    selectedTransaction.valorMovimentado | formatCurrency
                }}
              </td>
            </tr>

            <!-- ====================== CRYPTO (quando existir) ====================== -->
            <ng-container *ngIf="selectedTransaction?.cryptoTransaction">
              <tr>
                <td colspan="2" class="p-4"></td>
              </tr>

              <tr>
                <th>Moeda</th>
                <td>
                  {{
                    selectedTransaction.symbol?.name ||
                      selectedTransaction.cryptoTransaction?.symbol ||
                      "-"
                  }}
                </td>
              </tr>
              <tr>
                <th>Valor cripto</th>
                <td>
                  $
                  {{
                    selectedTransaction.cryptoTransaction?.cryptoValue != null
                      ? (selectedTransaction.cryptoTransaction.cryptoValue
                        | number : "1.0-4")
                      : "-"
                  }}
                </td>
              </tr>
              <tr>
                <th>Status cripto</th>
                <td>
                  <span
                    *ngIf="selectedTransaction.cryptoTransaction?.status"
                    class="status-badge"
                    [ngClass]="
                      formatStatusClass(
                        selectedTransaction.cryptoTransaction.status
                      )
                    "
                  >
                    {{
                      selectedTransaction.cryptoTransaction.status
                        | label : "status"
                    }}
                  </span>
                  <span *ngIf="!selectedTransaction.cryptoTransaction?.status"
                    >-</span
                  >
                </td>
              </tr>
              <tr>
                <th>Carteira</th>
                <td>
                  {{
                    selectedTransaction.wallet?.description ||
                      selectedTransaction.cryptoTransaction?.wallet ||
                      "-"
                  }}
                </td>
              </tr>
              <tr>
                <th>Hash carteira</th>
                <td>{{ selectedTransaction.wallet?.hash || "-" }}</td>
              </tr>
              <tr>
                <th>Rede</th>
                <td>{{ selectedTransaction.wallet?.network || "-" }}</td>
              </tr>
              <tr>
                <th>TxId</th>
                <td>
                  {{ selectedTransaction.cryptoTransaction?.txId || "-" }}
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer justify-content-start">
      <!-- <button
        *ngIf="canDownloadReceipt"
        class="our-button btn btn-pill btn-primary me-2"
        (click)="downloadReceipt(tableRowForReceipt)"
      >
        <i class="fe fe-download me-2"></i>
        {{ "common.downloadReceipt" | translate }}
      </button> -->

      <button
        *ngIf="canResendWebhook"
        class="our-button btn btn-pill btn-primary me-2"
        (click)="resendWebhook(selectedTransaction)"
      >
        <i class="fe fe-refresh-cw me-2"></i>
        {{ "common.resendWebhook" | translate }}
      </button>

      <button
        class="our-button btn btn-pill btn-primary ms-auto"
        (click)="modal.close()"
      >
        {{ "common.close" | translate }}
      </button>
    </div>
  </ng-container>

  <ng-template #loading>
    <div class="d-flex justify-content-center p-5">
      <div class="spinner-border"></div>
    </div>
  </ng-template>
</ng-template>
